import { httpClient } from '../../../shared/api/httpClient';

export interface User {
  id: number;
  username: string;
  email: string;
  first_name: string;
  last_name: string;
  is_superuser?: boolean;
}

export interface UserPermission {
  id: string;
  user_id: number;
  username: string;
  email: string;
  first_name: string;
  last_name: string;
  allowed_sites: string[];
  allowed_categories: string[];
  allowed_pages: string[];
  page_permissions: Record<string, boolean>;
}

export interface CreateUserRequest {
  email: string;
  username: string;
  password: string;
  first_name: string;
  last_name: string;
}

export interface UpdatePermissionRequest {
  user_id: number;
  allowed_sites: string[];
  allowed_categories: string[];
  allowed_pages: string[];
  page_permissions: Record<string, boolean>;
}

export async function getUsers(): Promise<User[]> {
  return httpClient.get<User[]>('/users/');
}

export async function createUser(data: CreateUserRequest): Promise<User> {
  return httpClient.post<User>('/users/create/', data);
}

export async function getUserPermissions(): Promise<UserPermission[]> {
  return httpClient.get<UserPermission[]>('/users/permissions/');
}

export async function getUserPermission(userId: number): Promise<UserPermission> {
  return httpClient.get<UserPermission>(`/users/permissions/${userId}/`);
}

export async function updateUserPermission(data: UpdatePermissionRequest): Promise<UserPermission> {
  return httpClient.post<UserPermission>('/users/permissions-update/', data);
}

export interface UserPermissions {
  is_superuser: boolean;
  allowed_sites: string[];
  allowed_categories: string[];
  allowed_pages: string[];
  page_permissions: Record<string, boolean>;
}

export async function getMyPermissions(): Promise<UserPermissions> {
  return httpClient.get<UserPermissions>('/users/me/permissions/');
}

